"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abs_csv_export_1 = __importDefault(require("./abs_csv_export"));
var contact_apply_object_1 = __importDefault(require("../../../common/src/utils/sales_force/contact_apply_object"));
var SalesForceContactApplyExport = /** @class */ (function (_super) {
    __extends(SalesForceContactApplyExport, _super);
    function SalesForceContactApplyExport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SalesForceContactApplyExport.prototype.getCsvData = function (contractDocument, salesForceInfo) {
        return contact_apply_object_1.default.create(contractDocument, salesForceInfo);
    };
    SalesForceContactApplyExport.prototype.getFileName = function () {
        return 'Contact_apply.csv';
    };
    return SalesForceContactApplyExport;
}(abs_csv_export_1.default));
exports.default = SalesForceContactApplyExport;



//////////////////
// WEBPACK FOOTER
// ./src/utils/sales_force/contact_apply_export.ts
// module id = H/px
// module chunks = 1